export enum FeatureTypeEnum {
  Website = 1,
  AdminBase = 2,
  SysAdmin = 3,
  AdminCustomer = 4,
  AdminAnnouncement = 5,
  AdminJobseeker = 6,
  AdminModeration = 7,
  AdminStats = 8,
  AdminSettings = 9,
  AdminCvDbProduct = 10,
  AdminSubscriber = 11,
  AdminPortfolio = 12,
  AdminTransactions = 13,
  AdminInvoices = 14,
  AdminPayments = 15,
  AdminEvents = 16,
  AdminSliderBannerProduct = 17,
  AdminCvBoxProduct = 18,
  AdminMatching = 19,
}
